module.exports = __webpack_public_path__ + "media/images/logo-uniube-77f2361f.png";